import { render, staticRenderFns } from "./customer-point-detail-modal.vue?vue&type=template&id=70011a28"
import script from "./customer-point-detail-modal.vue?vue&type=script&lang=js"
export * from "./customer-point-detail-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports